import React, { useEffect, useState } from 'react';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/core/styles';
import CssBaseline from '@material-ui/core/CssBaseline';
import Box from '@material-ui/core/Box';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import Container from '@material-ui/core/Container';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import Link from '@material-ui/core/Link';
import SharedUserDrawer, { DRAWER_WIDTH_LG, DRAWER_WIDTH_XL } from './SharedUserDrawer';
import logo5 from "../logo5.png"
import { useSelector, useDispatch } from "react-redux"
import { Button } from '@material-ui/core';
import * as AuthActions from "../../store/actions/auth";
import Auth from "../../Landingpagecomponents/Header/auth";
import { withRouter, useHistory } from "react-router-dom";
import Yourdiagnosis from './data/Yourdiagnosis';
import Prognosis from "./data/Prognosis";
import Recovery_phases from './data/recoveryPhases';
import { PatientHeaderContent } from "../../Landingpagecomponents/Header/headerPatient";

function Copyright() {
  return (
    <Typography variant="body2" color="textSecondary" align="center">
      {'Copyright © '}
      <Link color="inherit" href="https://material-ui.com/">
        Virtus Physio | Your Virtual Physiotherapist
      </Link>{' '}
      {new Date().getFullYear()}
      {'.'}
    </Typography>
  );
}

//logout
  //
  //

const drawerWidth = 178;

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
  },
  toolbar: {
    paddingRight: 24,
    minHeight: '50px !important',
    maxHeight: 50,
    [theme.breakpoints.up('xl')]: {
      minHeight: '57px !important',
      maxHeight: 57,
    },
  },
  toolbarIcon: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    padding: '0 6px',
    ...theme.mixins.toolbar,
  },
  appBar: {
    zIndex: theme.zIndex.drawer + 1,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    height: 50,
    maxHeight: 50,
    boxShadow: '0 2px 4px rgba(40,40,40,0.22), 0 2px 6px rgba(40,40,40,0.28)',
    [theme.breakpoints.up('xl')]: {
      height: 57,
      maxHeight: 57,
    },
  },
  responsiveLogo: {
    marginTop: 2,
    maxWidth: 200,
    minWidth: 165,
    [theme.breakpoints.down('xs')]: {
      maxWidth: 120,
      minWidth: 165,
    },
    [theme.breakpoints.up('sm')]: {
      maxWidth: 200,
      minWidth: 165,
    },
    [theme.breakpoints.up('md')]: {
      maxWidth: 200,
      minWidth: 165,
    },
    [theme.breakpoints.up('lg')]: {
      maxWidth: 250,
      minWidth: 165,
    },
    [theme.breakpoints.up('xl')]: {
      maxWidth: 250,
      minWidth: 165,
    },
  },
  appBarShift: {
    marginLeft: DRAWER_WIDTH_LG,
    width: `calc(100% - ${DRAWER_WIDTH_LG}px)`,
    [theme.breakpoints.up('xl')]: {
      marginLeft: DRAWER_WIDTH_XL,
      width: `calc(100% - ${DRAWER_WIDTH_XL}px)`,
    },
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  appBarSpacer: theme.mixins.toolbar,
  content: {
    flexGrow: 1,
    height: '100vh',
    overflow: 'auto',
  },
  container: {
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(2),
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
  },
  paper: {
    padding: theme.spacing(2),
    display: 'flex',
    overflow: 'auto',
    flexDirection: 'column',
  },
  fixedHeight: {
    height: 'auto',
  },
}));

export default function Overview() {
  const [isLoggedIn, setIsLoggedIn] = useState(useSelector(state => state.auth.isLoggedIn))

  const dispatch = useDispatch();
  const history = useHistory();

  const [selectedTreatmentId, setSelectedTreatmentId] = useState(null);
  const [treatments, setTreatments] = useState([]);


  const handleClickLogout = async () => { 
    console.log('[LOGOUT_HANDLER] handleClickLogout called');
    try {
      console.log('[LOGOUT_HANDLER] Dispatching logout action...');
      await dispatch(AuthActions.logout());
      console.log('[LOGOUT_HANDLER] Logout action completed, redirecting...');
    } catch (e) {
      console.error('[LOGOUT_HANDLER] Error during logout:', e);
      dispatch({type: AuthActions.LOGOUT});
    }
    console.log('[LOGOUT_HANDLER] Redirecting to home...');
    window.location.replace("/");
  };
//virker ovenstående som forventet?

  const classes = useStyles();
  const [open, setOpen] = useState(false);
  const handleDrawerOpen = () => setOpen(true);
  const handleDrawerClose = () => setOpen(false);
  
  const fixedHeightPaper = clsx(classes.paper, classes.fixedHeight);

  const token = useSelector(state => state.auth.token);
    const [loading, setLoading] = useState(true);
    const [phaseIndex, setPhaseIndex] = useState(null);
    const [isFetching, setIsFetching] = useState(false)
    const [phaseData, setPhaseData] = useState({
      progress: "?",
      title: "?"
    })
    const [diagnosis, setDiagnosis] = useState({
      title: "",
      explainer: "",
      identifier: ""
    })
  
    useEffect(() => {
      const fetchTreatments = async () => {
        if (!token) return;
        try {
          const res = await fetch('https://api.virtus-one.com/treatment/user/treatments/', {
            headers: { 'Authorization': `Token ${token}` },
            method: 'GET',
          });
          if (res.ok) {
            const data = await res.json();
            setTreatments(data);
            const saved = localStorage.getItem('vp_selectedTreatmentId');
            const defaultTreatment = saved && data.find(t => t.id === saved) ? saved : (data[0]?.id || null);
            setSelectedTreatmentId(defaultTreatment);
          }
        } catch (err) {
          console.error('Failed to fetch treatments', err);
        }
      };
      fetchTreatments();
    }, [token]);
  
    const fetchDiagnosisData = async () => {
      if (!selectedTreatmentId) return;
      
      setIsFetching(true);
      try {
        const response = await fetch(`https://api.virtus-one.com/treatment/phase/progress/treatment/${selectedTreatmentId}/`, {
          headers: { "Authorization": `Token ${token}` },
          method: "GET",
        });
        if (response.ok) {
          const data = await response.json();
          setDiagnosis({
            title: data.diagnosis_title || "",
            explainer: data.diagnosis_explainer || "",
            identifier: data.diagnosis_identifier || ""
          });
          setPhaseData({
            progress: data.progress,
            title: data.name,
            phaseIndex: data.phaseIndex
          });
          setPhaseIndex(data.phaseIndex);
        } else {
          alert("ERROR fetching phase data");
        }
      } catch (err) {
        console.error('Failed to fetch phase', err);
      }
      setIsFetching(false);
    };
  
    useEffect(() => {
      if (selectedTreatmentId) {
        fetchDiagnosisData();
      }
      // eslint-disable-next-line
    }, [selectedTreatmentId]);

  // Security check: verify authentication before rendering
  if (!isLoggedIn || !token) {
    window.location.replace("/");
    return <div>Redirecting...</div>;
  }

  if (isLoggedIn) {
    return (
      <div className={classes.root}>
        <CssBaseline />
        <AppBar style={{ color: "#002D55", background: '#FFFFFF' }} position="absolute" className={clsx(classes.appBar, open && classes.appBarShift)}>
          <Toolbar className={classes.toolbar}>
            <PatientHeaderContent 
              onLogout={handleClickLogout} 
              onProfile={() => history.push('/myaccount?tab=profile')} 
              onOpenVideo={() => {}} 
              onOpenCheckin={() => {}} 
              onTreatmentChange={(treatment) => {
                setSelectedTreatmentId(treatment.id);
              }}
            />
          </Toolbar>
        </AppBar>
        <SharedUserDrawer open={open} onOpen={handleDrawerOpen} onClose={handleDrawerClose} />
        <main className={classes.content} style={{background: 'linear-gradient(90deg, #dce4eb, #d7d4cf)'}}>
          <div className={classes.appBarSpacer}  />
          <Container key={selectedTreatmentId} maxWidth="100%" className={classes.container} >
            <Grid container spacing={0}>
              {/* Recent Deposits */}
              <Grid item xs={12} md={12} lg={12}>
                <Recovery_phases 
                  phaseIndex={phaseIndex}
                  treatmentId={selectedTreatmentId}
                />
              </Grid>
            </Grid>
            <Box pt={2}>
              <Copyright />
            </Box>
          </Container>
        </main>
      </div>
    );
  } else {
    return <div>Unauthorized</div>;
  }
}
